/**
 * The clock the daily's countdown is read off, shared by the two places that
 * show the daily (Home's card and the Daily tab) so they tick together.
 *
 * It ticks twice a minute, which is as fine as a figure in whole minutes
 * needs. When this device's day rolls over while the app is open, the new
 * daily is asked for, once.
 *
 * The state is a number of milliseconds, not a `Date`: a `Date` is mutable,
 * and a reader builds its own from the number.
 */
import { localDayKeyAt } from './daily-countdown.js';
import { refreshDaily } from './daily.svelte.js';

export const dailyClock = $state({ nowMs: Date.now() });

/** Starts the clock; returns what stops it. One caller: `App.svelte`. */
export function watchDailyClock(): () => void {
  let day = localDayKeyAt(Date.now());
  const timer = window.setInterval(() => {
    const nowMs = Date.now();
    dailyClock.nowMs = nowMs;
    const today = localDayKeyAt(nowMs);
    if (today === day) return;
    day = today;
    void refreshDaily();
  }, 30_000);
  return () => {
    window.clearInterval(timer);
  };
}
